import type { JSONConfig } from '@/engine/app/interfaces.ts';
import * as centerLines from './configs/centerLines.config.ts';
import * as imageStacks from '@/surgeries/cardiac/common/configs/imageStacks.config.ts';
import * as imageSlices from '@/engine/common/imageSlices.config.ts';
import * as viewPorts from '@/surgeries/cardiac/common/configs/viewPorts.config.ts';
import * as objects from '@/surgeries/cardiac/TTVR/configs/objects.config.ts';
import * as measurements from '@/surgeries/cardiac/TTVR/configs/measurements.config.ts';
import * as viewPortOrientations from '@/surgeries/cardiac/common/configs/viewPortOrientations.config.ts';
import { config as anatomyView } from '@/surgeries/cardiac/TTVR/configs/views/anatomyView.config.ts';
import { config as deviceView } from '@/surgeries/cardiac/TTVR/configs/views/deviceView.config.ts';
import { config as accessView } from '@/surgeries/cardiac/TTVR/configs/views/accessView.config.ts';
import { config as deliveryView } from '@/surgeries/cardiac/TTVR/configs/views/deliveryView.config.ts';
import { config as intraOpView } from '@/surgeries/cardiac/TTVR/configs/views/intraOpView.config.ts';

export const config: JSONConfig.Config = {
  imageStacks: [imageStacks.heart, imageStacks.body],
  centerLines: [centerLines.longAxis, centerLines.rightVessel, centerLines.leftVessel],
  objects: [
    objects.catheter,
    objects.valve,
    objects.arteriesAndKidneys,
    objects.vessel,
    objects.vesselColored,
    objects.veinsCalcification,
    objects.bones,
    objects.filter,
    objects.hardware,
    objects.leftAtrium,
    objects.leftVentricle,
    objects.aorta,
    objects.pulmonaryArtery,
    objects.rightAtrium,
    objects.rightVentricle,
    objects.rightHeart,
    objects.pt_AnteroseptalCommissure,
    objects.pt_AnteroposteriorCommissure,
    objects.pt_PosteroseptalCommissure,
    objects.landingZoneSpline,
    objects.eustachianRidgeSpline,
    objects.vesselCenterline,
    objects.tp_Pl_CustomDiameter,
    objects.tp_BasalRvA,
    objects.tp_BasalRvP,
    objects.tp_BasalRvS,
    objects.tp_BasalRvL,
    objects.tp_BasalRvTvA,
    objects.tp_BasalRvTvP,
    objects.tp_BasalRvTvS,
    objects.tp_BasalRvTvL,
    objects.tp_RaHeightPoint,
    objects.tp_RvDepthCoaxialPoint,
    objects.tp_RvDepthApexPoint,
    objects.tp_LeftFemoralArteryReferencePoint,
    objects.tp_RightFemoralArteryReferencePoint,
    objects.tp_CenterlineReferencePoint,
    objects.additionalDevice,
    objects.additionalStructure,
    objects.calcification
  ],
  viewPortOrientations: [viewPortOrientations.front],
  imageSlices: [imageSlices.axial, imageSlices.coronal, imageSlices.sagittal],
  viewPorts: [viewPorts.axial, viewPorts.coronal, viewPorts.sagittal, viewPorts.threeD],
  measurements: [
    measurements.landingZoneArea,
    measurements.varBasalRvAp,
    measurements.varBasalRvSl,
    measurements.varBasalRvTvAp,
    measurements.varBasalRvTvSl,
    measurements.tp_Pl_SvcAreaOne,
    measurements.tp_Pl_IvcAreaOne,
    measurements.tp_Pl_RightFemoralVesselMinArea,
    measurements.tp_Pl_LeftFemoralVesselMinArea,
    measurements.tp_Pl_CustomFemoralVesselMinArea,
    measurements.varCatheterRotationAngle,
    measurements.varCatheterSecondaryFlex,
    measurements.varCatheterPrimaryFlex,
    measurements.varCatheterToTvAngle,
    measurements.varRaHeight,
    measurements.varMaxRaHeight,
    measurements.varRvDepthCoaxial,
    measurements.varRvDepthApex,
    measurements.varIvcToTva,
    measurements.varIvcToTvaOffset,
    measurements.varRaVolume,
    measurements.varRvVolume,
    measurements.varAnnulusOversize,
    measurements.varBasalRvOversize,
    measurements.varPapillaryDistribution,
    measurements.varPapillaryDistanceCheck,
    measurements.varRaRvWorkingRoom,
    measurements.varLandingZonePdd
  ],
  views: [anatomyView, deviceView, accessView, deliveryView, intraOpView]
};
